module.exports = __webpack_public_path__ + "img/o3_ca.5695bab0.jpg";